import React from 'react'
import { ThemeProvider } from 'styled-components'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import { personCustomerType } from '../constants/GeneralConstants'
import favicon from '../images/favicon.ico'
import { GlobalStyle } from '../styles/global'
import theme from '../styles/theme'
import config from '../utils/siteConfig'

class Layout extends React.Component {

    render() {
        const { children, locale, metaTagTitle, customerType } = this.props

        return (
            <div className="siteRoot" style={customerType === personCustomerType ? {maxWidth: '1400px', margin: '0 auto'} : {}}>
              <>
                <Helmet>
                    <title>{metaTagTitle || config.siteTitle}</title>
                    <meta charSet="utf-8" />
                    <meta name="viewport" content="width=device-width, initial-scale=1" />
                    <link rel="icon" href={favicon} />
                    <meta name="description" content={config.siteDescription} />
                    <meta property="og:title" content={config.siteTitle} />
                    <meta property="og:locale" content={locale} />
                    <meta property="og:type" content="website" />
                    <meta property="og:site_name" content={config.siteTitle} />

                </Helmet>
                <ThemeProvider theme={theme}>
                  <>

                    <div className="siteContent">
                        {children}
                    </div>

                      <GlobalStyle />
                  </>
                </ThemeProvider>
              </>
            </div>
        )
    }
}

Layout.propTypes = {
    children: PropTypes.array,
    locale: PropTypes.string,
    customerType: PropTypes.string,
    metaTagTitle: PropTypes.string
}

Layout.defaultProps = {
    footer: true,
    header: true
}

export default Layout
